"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _qrcode = _interopRequireDefault(require("qrcode"));

var _index = require("./images/index");

var _popupWindowDesign = require("./popupWindowDesign");

var _debug = _interopRequireDefault(require("debug"));

var _config = require("../config");

var _events = _interopRequireDefault(require("events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// TODO add debug logging
var debug = (0, _debug.default)('MEWconnect:popup-window'); // const debugConnectionState = debugLogger('MEWconnect:connection-state');

var PopUpCreator = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PopUpCreator, _EventEmitter);

  var _super = _createSuper(PopUpCreator);

  function PopUpCreator() {
    var _this;

    _classCallCheck(this, PopUpCreator);

    _this = _super.call(this);
    _this.sessionId = '';
    _this.sessionId = false;
    _this.logo = _index.logo;
    _this.spaceman = _index.spaceman;
    _this.refreshIcon = _index.refresh;
    _this.playStoreButton = _index.playStoreButton;
    _this.appStoreButton = _index.appStoreButton;
    _this.camera = _index.camera;
    _this.closeIconBlack = _index.closeIconBlack;
    _this.popupWindowOpen = null;

    _this.windowClosedListener = function () {};

    if (!document.getElementById('Attach-Mew-Wallet-Modal')) {
      _this.container = window.document.createElement('div');
      _this.container.id = 'Attach-Mew-Wallet-Modal';
      window.document.body.appendChild(_this.container);
    } else {
      _this.container = document.getElementById('Attach-Mew-Wallet-Modal');
    }

    window.addEventListener('beforeunload', function () {
      _this.closePopupWindow();
    });
    return _this;
  }

  _createClass(PopUpCreator, [{
    key: "openPopupWindow",
    value: function openPopupWindow(text) {
      this.showPopupWindow(text);
    }
  }, {
    key: "window",
    get: function get() {
      return this.popupWindow;
    }
  }, {
    key: "setWindowClosedListener",
    value: function setWindowClosedListener(func) {
      this.windowClosedListener = func;
    }
  }, {
    key: "removeWindowClosedListener",
    value: function removeWindowClosedListener() {
      this.windowClosedListener = function () {};
    }
  }, {
    key: "hideNotifier",
    value: function hideNotifier() {
      var notify = document.getElementById('Notifications');
      notify.className = 'hidden';
    }
  }, {
    key: "createWindowInformer",
    value: function createWindowInformer() {
      var css = document.createElement('style');
      css.type = 'text/css';
      if ('textContent' in css) css.textContent = _popupWindowDesign.noticetext;else css.innerText = _popupWindowDesign.noticetext;
      this.container.appendChild(css);
      var div = window.document.createElement('div');
      div.id = 'Notifications';
      div.className = 'hidden';
      div.innerHTML = (0, _popupWindowDesign.windowInformer)(_index.spaceman);
      this.container.appendChild(div);
    }
  }, {
    key: "showWindowInformer",
    value: function showWindowInformer() {
      var _this2 = this;

      var notify = document.getElementById('Notifications');
      notify.className = 'shown';
      var showButton = document.getElementById('NotificationButton1');
      showButton.addEventListener('click', function () {
        _this2.showDialog();
      });
      var cancelButton = document.getElementById('NotificationButton2');
      cancelButton.addEventListener('click', function () {
        _this2.cancelConnectionSetup();
      });
    }
  }, {
    key: "cancelConnectionSetup",
    value: function cancelConnectionSetup() {
      try {
        this.popupWindowOpen = null;
        this.hideNotifier();
        this.closePopupWindow();
        this.windowClosedListener();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "showQrError",
    value: function showQrError() {
      var notify = document.getElementById('qr-failure');
      document.querySelector('#qrcodeError').classList.remove('is-visible');
      notify.className = 'hidden';
    }
  }, {
    key: "showConnecting",
    value: function showConnecting() {
      // todo: add existance checks because these are destroyed on a good connection
      document.querySelector('#qr-code-display-container-mew').classList.add('hidden');
      document.querySelector('#qr-code-connecting-mew').classList.remove('hidden');
    }
  }, {
    key: "hideConnecting",
    value: function hideConnecting() {
      document.querySelector('#qr-code-display-container-mew').classList.remove('hidden');
      document.querySelector('#qr-code-connecting-mew').classList.add('hidden');
    }
  }, {
    key: "showRetry",
    value: function showRetry(callback) {
      var retry = document.getElementById('retry-button-mew');
      var retryOnModal = document.getElementById('refresh-container');
      if (document.querySelector('#refresh-container')) document.querySelector('#refresh-container').classList.remove('hidden');
      if (document.querySelector('#retry-button-mew')) document.querySelector('#retry-button-mew').classList.remove('hidden');

      var eventHandler = function eventHandler(evt) {
        if (document.querySelector('#qr-code-display-container-mew')) document.querySelector('#qr-code-display-container-mew').classList.remove('hidden');
        if (document.querySelector('#qr-code-connecting-mew')) document.querySelector('#qr-code-connecting-mew').classList.add('hidden');
        if (document.querySelector('#retry-button-mew')) document.querySelector('#retry-button-mew').classList.add('hidden');
        if (document.querySelector('#refresh-container')) document.querySelector('#refresh-container').classList.add('hidden');
        if (retry) retry.removeEventListener('click', eventHandler, {
          passive: false,
          once: true
        });
        if (retryOnModal) retryOnModal.removeEventListener('click', eventHandler, {
          passive: false,
          once: true
        });
        callback();
      };

      if (retry) retry.addEventListener('click', eventHandler, {
        passive: false,
        once: true
      });
      if (retryOnModal) retryOnModal.addEventListener('click', eventHandler, {
        passive: false,
        once: true
      });
    }
  }, {
    key: "createQrCodeModal",
    value: function createQrCodeModal() {
      // this.popupWindowOpen = true;
      var modalId = 'Mew-Wallet-Modal';
      console.log(document.getElementById(modalId)); // todo remove dev item

      if (!!document.getElementById(modalId)) {
        debug('DONT NEED NEW'); // todo remove dev item

        return;
      }

      var css = document.createElement('style');
      css.type = 'text/css';
      if ('textContent' in css) css.textContent = (0, _popupWindowDesign.modalCSS)(_popupWindowDesign.cssStyles);else css.innerText = (0, _popupWindowDesign.modalCSS)(_popupWindowDesign.cssStyles);
      this.container.appendChild(css);
      var div = window.document.createElement('div');
      div.id = modalId; // div.className = 'hidden';

      div.innerHTML = (0, _popupWindowDesign.modalFrame)((0, _popupWindowDesign.htmlDesign)(this.refreshIcon, this.spaceman, this.playStoreButton, this.appStoreButton, this.camera, this.closeIconBlack, _config.IOS_LINK, _config.ANDROID_LINK)); // div.innerHTML = windowInformer(spaceman);

      this.container.appendChild(div);
    }
  }, {
    key: "hideDialog",
    value: function hideDialog(evt) {
      if (document.querySelector('.mew-wallet-modal') && document.querySelector('.mew-wallet-modal-container')) {
        document.querySelector('.mew-wallet-modal').classList.remove('is-visible');
        document.querySelector('.mew-wallet-modal-container').classList.remove('is-visible');
        document.querySelector('.modal-dialog').classList.remove('is-visible');
      }
    }
  }, {
    key: "showDialog",
    value: function showDialog(evt) {
      if (typeof this.popupWindowOpen !== 'boolean') return;
      this.popupWindowOpen = true;

      if (document.querySelector('.mew-wallet-modal') && document.querySelector('.mew-wallet-modal-container')) {
        document.querySelector('.mew-wallet-modal').classList.add('is-visible');
        document.querySelector('.mew-wallet-modal-container').classList.add('is-visible');
        document.querySelector('.modal-dialog').classList.add('is-visible');
      }
    }
  }, {
    key: "showPopupWindow",
    value: function showPopupWindow(qrcode) {
      var _this3 = this;

      try {
        if (typeof this.popupWindowOpen === 'boolean') {
          this.showDialog();
          return this.container;
        }

        if (!qrcode) {
          var QRfailedMessage = document.getElementById('qr-failure');
          QRfailedMessage.innerText = 'Error: Please start connection again.'; // todo Instead of not showing. present a notice and ask the user to retry.
          // this.emit('fatalError');
          // window.alert('Failed to create MEW wallet QRcode. Please retry.');
          // throw Error('No connection string supplied to popup window');
        }

        this.createQrCodeModal();
        this.createWindowInformer();
        var element = document.getElementById('canvas-for-mewconnect-qr-code');

        _qrcode.default.toCanvas(element, qrcode, {
          errorCorrectionLevel: 'H',
          width: 200
        });

        var background = document.getElementById('mew-wallet-modal');
        var background2 = document.getElementById('mew-wallet-modal-container');
        var dialog = document.getElementById('mew-mobile-modal-dialog');
        document.getElementById('close-mew-modal').addEventListener('click', function () {
          _this3.cancelConnectionSetup();
        });
        background.addEventListener('click', function (evt) {
          _this3.hideDialog();
        });
        background2.addEventListener('click', function (evt) {
          _this3.hideDialog(evt);
        });
        dialog.addEventListener('click', function (evt) {
          if (_this3.popupWindowOpen) {
            evt.stopPropagation();
          }
        }, false);
        this.showWindowInformer();
        this.popupWindow = this.container;
        this.popupWindowOpen = true;

        if (qrcode === '') {
          this.showQrError();
        }

        if (!qrcode) {
          var _QRfailedMessage = document.getElementById('qr-failure');

          _QRfailedMessage.innerText = 'Error: Please start connection again.'; // todo Instead of not showing. present a notice and ask the user to retry.

          this.emit('fatalError');
          window.alert('Failed to create MEW wallet QRcode. Please retry.');
          throw Error('No connection string supplied to popup window');
        }

        return this.container;
      } catch (e) {
        // todo Instead of not showing. present a notice and ask the user to retry.
        throw Error(e);
      }
    }
  }, {
    key: "updateQrCode",
    value: function updateQrCode(qrcode) {
      var element = document.getElementById('canvas-for-mewconnect-qr-code');

      _qrcode.default.toCanvas(element, qrcode, {
        errorCorrectionLevel: 'H',
        width: 200
      });
    }
  }, {
    key: "closePopupWindow",
    value: function closePopupWindow() {
      try {
        // this.hideDialog();
        this.popupWindowOpen = null;
        document.querySelector('#Attach-Mew-Wallet-Modal').dispatchEvent(new Event('mewModalClosed'));
        document.querySelector('#Attach-Mew-Wallet-Modal').replaceChildren(); // document.querySelector('#Attach-Mew-Wallet-Modal').classList.add('hidden');
      } catch (e) {
        this.popupWindowOpen = null;
        document.querySelector('#Attach-Mew-Wallet-Modal').innerHTML = '';
      }
    }
  }, {
    key: "handleBeforeUnload",
    value: function handleBeforeUnload() {// this.closePopupWindow();
    }
  }, {
    key: "resetSetup",
    value: function resetSetup() {
      this.popupWindowOpen = null;
      this.hideNotifier();
      this.closePopupWindow(); // document.getElementById('Attach-Mew-Wallet-Modal');
    }
  }]);

  return PopUpCreator;
}(_events.default);

exports.default = PopUpCreator;